export const apiRootUrl = process.env.API_URL;
